export interface TradeTransactionDisplay {
  entryTransactionID: string;
  exitTransactionID: string;
  company: string;
  ticker: string;
  action: 'Long' | 'Short';
  quantity: number;
  entryPrice: number;
  exitPrice: number;
  entryDate: Date;
  exitDate: Date;
  profit: number;
}

export interface StockHoldings {
  action: 'Long' | 'Short';
  ticker: string;
  stockOnHand: number;
  stockAveragePrice: number;
  purchaseTransaction: StockPurchaseTransaction[];
}

export interface StockPurchaseTransaction {
  entryTransactionID: string;
  quantity: number;
  entryPrice: number;
  entryDate: Date;
}

export interface StockSaleTransaction {
  action: 'Long' | 'Short';
  ticker: string;
  exitTransactionID: string;
  quantity: number;
  exitPrice: number;
  exitDate: Date;

  entryTransactionID: string;
  entryDate: Date;
  entryPrice: number;
}

export interface TradeRecord {
  action: 'Long' | 'Short';
  transactionType: 'Buy' | 'Sell';
  transactionDate: Date;
  ticker: string;
  quantity: number;
  price: number;
}

export const TRADE_HISTORY_TABLE_HEADERS = {
  entryTransactionId: 'Entry Transaction ID',
  exitTransactionId: 'Exit Transaction ID',
  company: 'Company',
  ticker: 'Ticker',
  quantity: 'Qty',
  action: 'Action',
  moneyIn: 'Entry Price',
  moneyOut: 'Exit Price',
  entryDate: 'Entry Date',
  exitDate: 'Exit Date',
  pnlPercent: 'P/L(%)',
  pnlAmt: 'P/L($)',
};
